
import CustomerVehicleSelectorSidebar from 'JS/automotive/shared/components/CustomerVehicleSelectorSidebar.vue';
import FieldNote from 'JS/components/FieldNote.vue';
import Icon from 'JS/components/Icon.vue';
import UiButton from 'JS/components/UiButton.vue';
import { computed, defineComponent, ref } from 'vue';
import { ICustomerVehicle } from 'JS/types/Automotive';
import { useOrderStore } from 'JS/automotive/auto-service-scheduler/state/order';

export default defineComponent({
	name: 'AddVehicle',
	components: {
		CustomerVehicleSelectorSidebar,
		FieldNote,
		Icon,
		UiButton
	},
	props: {
		isTire: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const orderStore = useOrderStore();

		const showVehicleLookupSidebar = ref(false);
		const vehicleError = ref(false);

		const vehicleAction = computed(() => {
			if (props.isTire) {
				return 'to make sure these tires fit';
			}

			return 'to select services';
		});

		function addVehicle(): void {
			showVehicleLookupSidebar.value = true;
		}

		async function setVehicle(newVehicle: ICustomerVehicle): Promise<void> {
			showVehicleLookupSidebar.value = false;
			await orderStore.setVehicle(newVehicle);
		}

		return {
			addVehicle,
			setVehicle,
			showVehicleLookupSidebar,
			vehicleAction,
			vehicleError
		};
	}
});
